import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import MobileHeader from "../../components/MobileHeader";
import CreditGauge from "../../components/CreditGauge";
import ShareScoreDialog from "../../components/ShareScoreDialog";
import { Button } from "../../components/ui/button";
import { CheckCircle2, AlertCircle, Sparkles, Share2 } from "lucide-react";

export default function ScoreFactors() {
    const [data, setData] = useState(null);
    const [shareOpen, setShareOpen] = useState(false);

    useEffect(() => {
        api.get("/credit/score").then((r) => setData(r.data));
    }, []);

    return (
        <div data-testid="score-factors-page">
            <MobileHeader title="Credit DNA Score™" subtitle="Your credit health" backTo="/consumer" />
            <div className="px-5 -mt-6 pb-4 space-y-4">
                <div className="bg-white rounded-2xl border border-slate-200 p-5 product-shadow flex flex-col items-center">
                    {data ? (
                        <CreditGauge score={data.score} grade={data.grade} size={200} label="" />
                    ) : (
                        <div className="h-40 flex items-center text-slate-400">Calculating…</div>
                    )}
                    {data && (
                        <Button
                            onClick={() => setShareOpen(true)}
                            className="mt-4 h-11 rounded-xl bg-gradient-to-r from-[#7000FF] to-[#FF0055] hover:opacity-90 font-semibold px-6"
                            data-testid="share-score-btn"
                        >
                            <Share2 size={16} /> Share my score
                        </Button>
                    )}
                </div>

                {data?.explanation && (
                    <div className="bg-gradient-to-br from-violet-50 to-blue-50 rounded-2xl border border-violet-200 p-5">
                        <div className="flex items-center gap-2 text-[#7000FF] font-bold text-xs uppercase tracking-wider">
                            <Sparkles size={14} /> AI insights
                        </div>
                        <p className="text-sm text-slate-700 mt-2 leading-relaxed">{data.explanation}</p>
                        <div className="mt-3 space-y-2">
                            {(data.tips || []).map((t, i) => (
                                <div key={i} className="flex gap-2 text-xs text-slate-700">
                                    <CheckCircle2 size={14} className="text-[#00D084] flex-shrink-0 mt-0.5" />
                                    <span>{t}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div className="bg-white rounded-2xl border border-slate-200/60 p-5">
                    <div className="font-display font-semibold text-[#0A1930] mb-3">Score Factors</div>
                    <div className="space-y-3">
                        {(data?.factors || []).map((f, i) => (
                            <div key={i} className="flex items-start gap-3" data-testid={`factor-${i}`}>
                                <div className={`size-8 rounded-lg flex items-center justify-center flex-shrink-0 ${f.positive ? "bg-emerald-50 text-emerald-600" : "bg-amber-50 text-amber-600"}`}>
                                    {f.positive ? <CheckCircle2 size={16} /> : <AlertCircle size={16} />}
                                </div>
                                <div className="flex-1">
                                    <div className="font-semibold text-sm text-[#0A1930]">{f.name}</div>
                                    <div className="text-xs text-slate-500">{f.weight} weight · {f.impact}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <ShareScoreDialog open={shareOpen} onClose={() => setShareOpen(false)} />
        </div>
    );
}
